<template>
    <div
        class="row-children-box"
        :class="{focus: form.focus}"
    >
        <p class="title">{{form.title}}</p>
        <RowBox
            :form.sync="form.operationArray"
            @onBtns="onBtns"
        ></RowBox>
    </div>
</template>

<script>
    export default {
        name: "RowChildrenBox",
        props: {
            form: [Object,Array]
        },
        width: {
            form(vl){this.newForm=vl},
            newForm(vl){this.$emit('update:form', vl)}
        },
        data(){
            return {
                newForm: this.form
            }
        },
        methods: {
            onBtns (obj){
                this.$emit('onBtns', obj)
            }
        }
    }
</script>

<style lang="scss" scoped>
.row-children-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px 50px 10px;
    border-bottom: 1px solid #EBEEF5;

    &.focus{
        background-color: #E4E7ED;
    }

    .title{
        width: 180px;
        margin-left: 10px;
    }

    .row{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 20px;

        .name{
            margin-right: 10px;
        }
    }
}
</style>
